import React from "react";

export default () => (
  <div>Document Templates (@TODO: Migrate document templates page)</div>
);
